import { getCurrentAgenda } from "../../../router/selectors"
import { getQueryFromDateOnly, getQueryToDateOnly } from "../selectors"
import type { StateObject } from "../../../redux/types"
import {
    getFilters,
    getSelectedLocationIdsFromGlobalFilter,
    getTimezoneForQueryParam,
} from "../../../filters/selectors"
import { GLOBAL_FILTER_IDENTIFIER } from "../../../filters/reducer"
import { MainMenuAgendaEnum } from "../../../router/types"
import type { SalesByItemsReportRequestData } from "../../../../graphql/types"
import { formatDateTime } from "../../../../utils/formatters"

export const isSalesByItemsReportAgendaOpened = (state: StateObject) =>
    getCurrentAgenda(state) === MainMenuAgendaEnum.SalesByItemsReport

export const getSalesByItemsReportV2QueryApiParam = (state: StateObject): SalesByItemsReportRequestData => {
    const locationIds = getSelectedLocationIdsFromGlobalFilter(state)?.join() || null
    return {
        from: getQueryFromDateOnly(state),
        to: getQueryToDateOnly(state),
        ...(locationIds
            ? {
                  locationIds: locationIds,
              }
            : null),
    }
}

export const getSalesByModifiersReportQueryApiParam = (
    state: StateObject,
    forCsv: boolean
): SalesByItemsReportRequestData => {
    const globalFilters = getFilters(state, GLOBAL_FILTER_IDENTIFIER)
    const locationIds = getSelectedLocationIdsFromGlobalFilter(state)?.join() ?? null
    const from =
        globalFilters.timestamp &&
        globalFilters.timestamp.from &&
        formatDateTime(globalFilters.timestamp.from, "YYYY-MM-DD")
    const to =
        globalFilters.timestamp &&
        globalFilters.timestamp.to &&
        formatDateTime(globalFilters.timestamp.to, "YYYY-MM-DD")
    const locationIdsKey = forCsv ? "location_ids" : "locationIds"
    return {
        from: from,
        to: to,
        timezone: getTimezoneForQueryParam(state, getSelectedLocationIdsFromGlobalFilter(state)),
        ...(locationIdsKey
            ? {
                  [locationIdsKey]: locationIds,
              }
            : null),
    }
}
